import MathUtils from './MathUtils'
import ConversionUtils from './ConversionUtils'
import resourceManager from '@/resource/ResourceManager'
import dateFormat from "dateformat";

var FormatUtils = {

	METRIC_SYSTEM: "metric",
	IMPERIAL_SYSTEM: "imperial",
	NAUTICAL_SYSTEM: "nautical",
	currentSystem: "metric",
	formatElevation: function(elevationInMeters, system) {
		system = (typeof system === 'undefined')?this.currentSystem:system;
		if (isNaN(elevationInMeters)) {
			return "";
		}
		var negative = elevationInMeters < 0;
		var meters = Math.abs(Math.round(elevationInMeters));
		if (meters != 0) {
			var result = "";
			if (negative) {
				result += "-";
			}
			if (system == this.METRIC_SYSTEM) {
				result = result + meters + " m";
			} else {
				var feet = Math.round(ConversionUtils.metersToFeet(meters));
				if (feet >= 10) {
					result = result + Math.round(feet) + "'";
				} else if (feet >= 1) {
					result = result + Math.ceil(feet) + "'";
					var inches = Math.round((feet-Math.ceil(feet))/12);
					if (inches > 0) {
						result = result + " " + inches + "''";
					}
				} else {
					result = result + Math.round(feet / 12) + "''";
				}
				
			}
			return result;
		}
		return "-";
	},
	
	formatDuration: function (pMinutes) {
		if (isNaN(pMinutes)) {
			return "";
		}
		var result = "";
		if (pMinutes > 0) {
			var minutes = pMinutes%60;
			var hours = Math.floor(pMinutes/60);
			if (hours > 0) {
				result = result + hours + "h";
				if (minutes == 0) {
					result += "00"
				} else if (minutes < 10) {
					result = result + "0" + minutes;
				} else {
					result += minutes;
				}
			} else {
				result = result + minutes + " min.";
			}
			
			return result;
		}
		return "0 min.";
	},
	formatBoolean: function(value) {
		if (value) {
			return resourceManager.getString("main", "yes_boolean_value");
		}
		return resourceManager.getString("main", "no_boolean_value");
	},
	formatDate: function(date) {
		if (date != null) {
			return dateFormat(date, resourceManager.getString("main", "short_date_format"));
		}
		return "";
	},
	formatDateTime: function(dateTime) {
		if (dateTime != null) {
			return dateFormat(dateTime, resourceManager.getString("main", "short_datetime_format"));
		}
		return "";
	},
	formatTime: function(time) {
		if (time != null) {
			return dateFormat(time, resourceManager.getString("main", "time_format"));
		}
		return "";
	},
	formatSpeed: function(metersPerHour, system) {
		system = (typeof system === 'undefined')?this.currentSystem:system;
		if (isNaN(metersPerHour)) {
			return "";
		}
		if (system == this.IMPERIAL_SYSTEM) {
			// mph 
			var miles = MathUtils.roundToDecimal(ConversionUtils.metersToMiles(metersPerHour), 1);
			return MathUtils.roundToDecimal(miles, 1) + " mph";
		} else if (system == this.NAUTICAL_SYSTEM) {
			// nautical knots
			return MathUtils.roundToDecimal(ConversionUtils.metersPerHourToKnots(metersPerHour), 1) + " knots";
		} else if (metersPerHour >= 1000) {
			// kilometers
			return MathUtils.roundToDecimal(metersPerHour/1000, 1) + " km/h";
		}
		return MathUtils.roundToDecimal(metersPerHour, 0) + " m/h";
	},
	formatWeight: function(grams, system) {
		system = (typeof system === 'undefined')?this.currentSystem:system;
		if (!isNaN(grams)) {
			if (system == this.METRIC_SYSTEM) {
				
				if (grams >= 1000) {
					return MathUtils.roundToDecimal(grams/1000, 1) + " kg";
				} else if (grams < 1) {
					return Math.round(grams*1000) + " mg";
				}
				return Math.round(grams) + " g";
			} else {
				var pounds = ConversionUtils.gramsToPounds(pounds);
				if (pounds < 1) {
					var ounces = Math.round(pounds*16);
					return ounces + " oz.";
				}
				var lbs = Math.round(pounds*100)/100;
				return lbs.toPrecision(2) + " lbs";
			}
		}
		return "";	
	},
	
	formatDistance: function(meters, system) {
		system = (typeof system === 'undefined')?this.currentSystem:system;
		if (isNaN(meters)) {
			return "";
		}
		if (system == this.METRIC_SYSTEM) {
			if (meters >= 1000) {
				// kilometers
				return MathUtils.roundToDecimal(meters/1000, 1) + " km";
			}
			return MathUtils.roundToDecimal(meters, 0) + " m";
		} else if (system == this.NAUTICAL_SYSTEM) {
			var nmi = ConversionUtils.metersToNauticalMiles(meters);
			nmi = Math.round(nmi*100)/100;
			return nmi.toPrecision(2) + " nmi";
		}
		var miles = ConversionUtils.metersToMiles(meters);
		if (miles >= 0.5) {
			miles = Math.round(miles*100)/100;
			return miles.toPrecision(2) + " mi";
		}
		return this.formatElevation(meters, system);
			
	},
	formatShortDistance: function(centimeters, system) {
		system = (typeof system === 'undefined')?this.currentSystem:system;
		if (isNaN(centimeters)) {
			return "";
		}
		if (system == this.NAUTICAL_SYSTEM || system == this.IMPERIAL_SYSTEM) {
			// inches
			var inches = MathUtils.roundToDecimal(ConversionUtils.centimetersToInches(centimeters), 1);
			return MathUtils.roundToDecimal(inches, 1) + " in.";
		}
		return MathUtils.roundToDecimal(centimeters, 1) + " cm";
	}


};

export default FormatUtils;